import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useState, useCallback, useMemo } from 'react';
import { createUseStyles, Text, RadioGroup, Modal, Icon, Link, Multiplier, Loader, Advice } from 'hoi-poi-ui';
import { useWeb5Context } from "../../../../lib/Web5Context";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'UpdateOptions');
var _ref2 = /*#__PURE__*/React.createElement(Loader, null);
const UpdateOptions = _ref => {
  let {
    idType,
    onChangeIdType,
    syncNames,
    onChangeSyncNames,
    fields,
    entityLabel
  } = _ref;
  const classes = useStyles();
  const {
    t
  } = useWeb5Context();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpenModal = useCallback(() => setIsModalOpen(true), []);
  const handleCloseModal = useCallback(() => setIsModalOpen(false), []);
  const onClick = useCallback(e => e.stopPropagation(), []);
  const filteredFields = useMemo(() => fields === null || fields === void 0 ? void 0 : fields.map(field => {
    var _syncNames$map;
    return _objectSpread(_objectSpread({}, field), {}, {
      isDisabled: syncNames === null || syncNames === void 0 ? void 0 : (_syncNames$map = syncNames.map(el => el === null || el === void 0 ? void 0 : el.value)) === null || _syncNames$map === void 0 ? void 0 : _syncNames$map.includes(field === null || field === void 0 ? void 0 : field.value)
    });
  }), [syncNames, fields]);
  const options = useMemo(() => [{
    label: t('cfm_label_id'),
    value: 'id',
    className: 'import-export__import-type--update-id--id'
  }, {
    label: t('cmf_label_import_others'),
    value: 'others',
    className: 'import-export__import-type--update-id--other'
  }], [t]);
  const schema = useMemo(() => ({
    name: 'field',
    type: 'select',
    labelMode: 'vertical',
    attrs: {
      options: filteredFields
    }
  }), [filteredFields]);
  const modalClasses = useMemo(() => ({
    header: classes.modalInfoHeader
  }), [classes.modalInfoHeader]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.chooseId,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.chooseIdLabelContainer
  }, /*#__PURE__*/React.createElement(Icon, {
    className: classes.chooseIdLabelIconEdit,
    name: "edit"
  }), /*#__PURE__*/React.createElement(Text, {
    type: "subtitle"
  }, t('cfm_label_import_identifier'), " "), /*#__PURE__*/React.createElement(Icon, {
    name: "info",
    size: "small",
    className: classes.chooseIdLabelIcon,
    onClick: handleOpenModal
  })), /*#__PURE__*/React.createElement(Advice, {
    className: classes.chooseIdAdvice,
    type: "info",
    showIcon: true,
    showCollapse: false
  }, t('cfm_label_import_recommned_id', [entityLabel, entityLabel, entityLabel, entityLabel])), /*#__PURE__*/React.createElement(RadioGroup, {
    className: classes.radioGroup,
    labelMode: "vertical",
    options: options,
    onChange: onChangeIdType,
    value: idType,
    orientation: "horizontal"
  }), idType === 'others' && fields && /*#__PURE__*/React.createElement(Multiplier, {
    name: "syncNames",
    className: classes.multiplier,
    buttonLabel: t('cfm_action_add_field'),
    buttonClassName: classes.multiplierAddButton,
    value: syncNames || [],
    schema: schema,
    separator: false,
    onChange: onChangeSyncNames,
    labelMode: "vertical",
    isFullWidth: true
  }), idType === 'others' && !fields && /*#__PURE__*/React.createElement("div", {
    className: classes.multiplierLoader
  }, _ref2), /*#__PURE__*/React.createElement(Modal, {
    classes: modalClasses,
    title: t('cfm_label_import_identifier'),
    isOpen: isModalOpen,
    useCornerClose: false,
    onConfirm: handleCloseModal,
    confirmText: t('cfm_action_done_2')
  }, /*#__PURE__*/React.createElement(Text, {
    className: classes.modalInfoText
  }, t('cfm_label_import_identifier_Info_1')), /*#__PURE__*/React.createElement(Text, {
    className: classes.modalInfoText
  }, t('cfm_label_import_identifier_Info_2')), /*#__PURE__*/React.createElement(Text, {
    className: classes.modalInfoText
  }, t('cfm_label_import_identifier_Info_3')), /*#__PURE__*/React.createElement(Link, {
    className: classes.modalInfoLink,
    href: t('cfm_label_import_identifier_more_info'),
    target: "_blank"
  }, t('cfm_action_more_info'))));
};
UpdateOptions.propUpdateOptionss = {};
export default /*#__PURE__*/memo(UpdateOptions);